export const HELP_LINK = {
  'Container size overflowed': 'https://www.galacean.com/effects/user/gasrv4ka5sacrwpg#MvjnY',
  'DPI overflowed': 'https://www.galacean.com/effects/user/gasrv4ka5sacrwpg#ulfNT',
  'Invalid container size': 'https://www.galacean.com/effects/user/gasrv4ka5sacrwpg#lLlSW',
  'Container is not an HTMLElement': 'https://www.galacean.com/effects/user/gasrv4ka5sacrwpg#WZaWg',
  'Never use destroyed player again': 'https://www.galacean.com/effects/user/gasrv4ka5sacrwpg#YSWQr',
  'Current running player count': 'https://www.galacean.com/effects/user/gasrv4ka5sacrwpg#IzodZ',
  'Create player with different WebGL version': 'https://www.galacean.com/effects/user/gasrv4ka5sacrwpg#X0ulg',
};
